import { DashboardModule, Form } from '@domain-group/suit-theme'

import type { UseFormPayload } from '@domain-group/react-hooks'

import type { EntitiesState } from '@redux/entities'

import useCurrentUser from '@hooks/useCurrentUser'
import useSelector from '@hooks/useSelector'

import SuburbSearch from '@components/SuburbSearch'

import type { AgencyModel, CampaignModel, GeoSuburbModel } from '@models/types'

type HandleSelectItemParams = {
  geoStates: EntitiesState['geoStates'],
  geoSuburb: GeoSuburbModel,
  setEntityState: UseFormPayload['setEntityState'],
}

const handleSelectItem = (params: HandleSelectItemParams) => {
  const { geoStates, geoSuburb, setEntityState } = params

  setEntityState({
    post_code: geoSuburb?.post_code,
    state_id: geoSuburb?.geo_state_id,
    state_name: geoStates[geoSuburb.geo_state_id]?.code,
    suburb_id: geoSuburb?.id,
    suburb_name: geoSuburb?.title,
  })
}

interface BrandGroupDetailsProps {
  agency: AgencyModel,
  campaign: CampaignModel,
  campaignFormPayload: UseFormPayload,
}

const BrandGroupDetails = (props: BrandGroupDetailsProps) => {
  const { agency, campaign, campaignFormPayload } = props

  const { address } = campaign
  const { geo_country_id } = agency

  const {
    entityState: {
      post_code,
      suburb_name,
      state_name,
    },
    handlers,
    setEntityState,
  } = campaignFormPayload

  const { geoStates } = useSelector(reduxState => reduxState.entities)

  const { isAdmin } = useCurrentUser()

  const searchCallbacks = {
    onChange: (value: string) => setEntityState({ suburb_name: value }),
    selectItem: (geoSuburb: GeoSuburbModel) => handleSelectItem({ geoStates, geoSuburb, setEntityState }),
  }

  return (
    <DashboardModule title="Property Details">
      <Form padding="large">
        <Form.Row>
          <Form.Field label="* Address">
            <input
              disabled
              name="address"
              value={address}
            />
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field label="Suburb" marginTop={['large', 0]}>
            <SuburbSearch
              callbacks={searchCallbacks}
              requestOptions={{ geo_country_id }}
              value={suburb_name}
            />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field label="* State">
            <input
              disabled={!isAdmin}
              name="state_name"
              type="text"
              value={state_name}
              {...handlers}
            />
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field label="* Postcode" marginTop={['large', 0]}>
            <input
              disabled={!isAdmin}
              name="post_code"
              value={post_code}
              type="text"
              {...handlers}
            />
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

export default BrandGroupDetails
